export default {
    methods: {
        formatKpiInteger(value) {
            return Number(value ?? 0).toLocaleString('it-IT');
        },
        formatKpiMoney(value) {
            return Number(value ?? 0).toLocaleString('it-IT', {
                style: 'currency',
                currency: 'EUR',
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
            });
        },
        formatKpiValue(value, key) {
            if (key === 'order_value' || key === 'shipping_value') {
                return this.formatKpiMoney(value);
            }

            return this.formatKpiInteger(value);
        },
    },
};
